import {
  PRODUCTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  PRODUCTS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  PRODUCTS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  PRODUCTS_MASSIVE_UPLOAD_SET_VERIFY,
  PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_VERIFY,
  PRODUCTS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  PRODUCTS_MASSIVE_UPLOAD_SET_UPLOAD,
  PRODUCTS_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function productsMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case PRODUCTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case PRODUCTS_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case PRODUCTS_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case PRODUCTS_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case PROCESS__DATES_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case PRODUCTS_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case PRODUCTS_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case PRODUCTS_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default productsMassiveUploadReducer;
